import { useEffect, useSyncExternalStore } from "react";
import { api } from "@/lib/api";
import { applyPalette, untagPalette } from "@/lib/theme";

let list = null, loading = null;
const subs = new Set();
const emit = () => subs.forEach((fn) => fn());
const set = (next) => { list = next; emit(); };

export const loadPalettes = () => {
  if (list || loading) return loading || Promise.resolve(list);
  loading = api.get("/palettes").then(({ data }) => { set(data); loading = null; return data; }).catch(() => { loading = null; return []; });
  return loading;
};
export const resetPalettes = () => { loading = null; set(null); };

export const usePalettes = () => {
  const v = useSyncExternalStore((fn) => { subs.add(fn); return () => subs.delete(fn); }, () => list);
  useEffect(() => { if (!v) loadPalettes(); }, [v]);
  return v || [];
};

const sameColors = (a, b) => a.length === b.length && a.every((c, i) => c === b[i]);
export const findSaved = (colors) => (list || []).find((p) => sameColors(p.colors, colors)) || null;

export const defaultName = (d = new Date()) => `Palette · ${d.toLocaleDateString(undefined, { month: "short", day: "numeric" })}`;

export async function savePalette(colors, name = defaultName()) {
  const { data } = await api.post("/palettes", { name, colors });
  set([data, ...(list || [])]);
  applyPalette(data);
  return data;
}
export async function renamePalette(id, name) {
  const { data } = await api.patch(`/palettes/${id}`, { name });
  set((list || []).map((p) => (p.id === id ? data : p)));
}
export async function deletePalette(id) {
  await api.delete(`/palettes/${id}`);
  set((list || []).filter((p) => p.id !== id));
  untagPalette(id);
}
